import UserRequests from '../../../utils/requests/user';
import Dependencies from '@/dependencyContainer/dependenciesList';

export default {
    data() {
        return {
            addDialog: {
                show: false
            }
        };
    },

    methods: {
        addUser() {
            this.addDialog.show = true;
        },

        async storeUser(payload) {
            const { groupId, ...userPayload } = payload;
            try {
                const newUser = await UserRequests.addUser(userPayload);
                if (groupId) {
                    const userGroupReq = await this.$dc.get(Dependencies.UserGroupRequests);
                    await userGroupReq.addUserToGroup(groupId, newUser.user.id);
                }
            } catch (error) {
                const data = error?.response?.data;
                const errorMsg = data?.statusCode + ' ' + data?.error + ': ' + data?.message;
                alert(errorMsg);
            }
            this.addDialog.show = false;
        }
    }
};
